import React from 'react';

export interface IWorkIntervalDataRequestGuardContext {
  iConfirmThatThisComponentDispatchesWorkIntervalRequestAction: boolean;
}

export const WorkIntervalDataRequestGuardContext = React.createContext<IWorkIntervalDataRequestGuardContext>({
  iConfirmThatThisComponentDispatchesWorkIntervalRequestAction: false,
});
